import React from 'react';
import { ShieldCheck, FileCheck2, ScrollText } from 'lucide-react';

const LocalFirst = () => {
  return (
    <section id="local-first" className="my-20">
      <div className="bg-gradient-to-br from-apple-800/60 to-apple-900/60 backdrop-blur-md rounded-3xl border border-apple-700/40 p-8 sm:p-12 relative overflow-hidden">
        <div className="absolute -left-32 -top-32 w-72 h-72 rounded-full bg-sortio-primary/10 blur-[100px]" />
        <div className="absolute -right-32 -bottom-32 w-72 h-72 rounded-full bg-sortio-secondary/10 blur-[100px]" />

        <div className="relative z-10">
          <div className="flex items-center mb-6">
            <div className="w-12 h-12 rounded-full bg-sortio-primary/15 border border-sortio-primary/30 flex items-center justify-center mr-4">
              <ShieldCheck className="text-sortio-primary" size={22} />
            </div>
            <span className="text-xs font-medium uppercase tracking-wider text-sortio-primary">
              Privacy by design
            </span>
          </div>

          <h2 className="text-3xl sm:text-4xl font-semibold mb-6 tracking-tight text-apple-50 max-w-3xl">
            Keep your books on your own machine
          </h2>

          <div className="max-w-3xl space-y-5 text-apple-200 leading-relaxed">
            <p>
              Sortio reads files on your Mac or PC. When it opens a vendor invoice to extract the
              amount and date, that read happens locally. In Offline mode with a local LLM
              (Ollama), or with Bring Your Own Key against your own provider account, the file
              content stays on your machine. Your OneDrive stays your OneDrive, your Dropbox stays
              your Dropbox.
            </p>
            <p>
              By default Sortio uses our cloud (OpenAI) to plan the sort, which sends filenames
              and folder paths; invoice contents are sent only if you turn on a content-based
              feature like AI rename by content. For bookkeepers handling payroll and vendor
              banking details, run Sortio in Offline mode or BYOK and there is no Sortio-side cloud
              step where your client's financials pass through a third party.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10">
            <div className="bg-apple-800/40 rounded-2xl border border-apple-700/50 p-6">
              <div className="flex items-center mb-3">
                <FileCheck2 className="text-sortio-primary mr-2" size={18} />
                <h3 className="text-base font-medium text-apple-50">Works with your stack</h3>
              </div>
              <p className="text-sm text-apple-200 leading-relaxed">
                Sortio works on OneDrive, Dropbox, SharePoint, and local drives. It plays well
                with QuickBooks and Xero exports, files renamed by Sortio drop straight into
                your accounting workflow without remapping.
              </p>
            </div>

            <div className="bg-apple-800/40 rounded-2xl border border-apple-700/50 p-6">
              <div className="flex items-center mb-3">
                <ScrollText className="text-sortio-primary mr-2" size={18} />
                <h3 className="text-base font-medium text-apple-50">Audit trail</h3>
              </div>
              <p className="text-sm text-apple-200 leading-relaxed">
                Every move is logged locally with the source path, destination, and the AI's
                confidence score. If an invoice lands in the wrong vendor folder, you can trace
                exactly what happened and undo it in one click.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocalFirst;
